/** Dotted version compare ("1.0.13" >= "1.0.9"); null/garbage never passes. */
export function versionAtLeast(version: string | null | undefined, min: string): boolean {
  if (!version) return false;
  const parse = (v: string) => v.trim().split('.').map((n) => parseInt(n, 10));
  const a = parse(version);
  const b = parse(min);
  if (a.some((n) => Number.isNaN(n))) return false;
  for (let i = 0; i < Math.max(a.length, b.length); i++) {
    const x = a[i] ?? 0;
    const y = b[i] ?? 0;
    if (x !== y) return x > y;
  }
  return true;
}
